import React from 'react'

const StarIcon = ({ className, size = 24, color = 'currentColor', filled = false }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="star-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 220, 100, 1)" />
          <stop offset="50%" stopColor="rgba(255, 180, 100, 1)" />
          <stop offset="100%" stopColor="rgba(255, 150, 100, 1)" />
        </linearGradient>
        <filter id="star-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <path 
        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" 
        fill={filled ? "url(#star-gradient)" : "none"}
        stroke="url(#star-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        filter="url(#star-glow)"
      />
      {filled && (
        <>
          <circle cx="12" cy="10" r="1" fill="rgba(255, 255, 255, 0.8)" />
          <circle cx="10" cy="12" r="0.5" fill="rgba(255, 255, 255, 0.6)" />
          <circle cx="14" cy="12" r="0.5" fill="rgba(255, 255, 255, 0.6)" />
        </>
      )}
    </svg>
  )
}

export default StarIcon
